import Box from "@mui/material/Box";
import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export const StyledBackground = ({ children }: Props) => {
  return (
    <Box width={"100%"} pb={3} sx={{ backgroundColor: (theme) => theme.colors.backgroundSecondary }}>
      {children}
    </Box>
  );
};
